import {h, Fragment} from "preact"
import { useState } from 'preact/hooks'
import ArticleBlog from './ArticleBlog'
import useArticlesBlogs from './useArticlesBlogs'
import { defaultConfig } from '../config'

export default ({ resultsView }) => {
    const { resultArticlesBlogs } = useArticlesBlogs();
    const [ articlesShown, setArticlesShown ] = useState(defaultConfig.serpSize);

    const loadMore = () => {
        setArticlesShown(prevArticlesShown => prevArticlesShown + defaultConfig.serpSize)
    }

    return (
        <div 
            id="ns-articles-view" 
            hidden={resultsView !== 'articles'} 
            role="region" 
            aria-live="polite"
        >
            <div class="product-facet__product-list product-list">
                <div class="product-list__inner">
                    {(resultArticlesBlogs.length > 0)
                        ?   resultArticlesBlogs.slice(0, articlesShown).map(item => (
                                <ArticleBlog item={item} />
                            ))
                        :   <div>No results found.</div>
                    }
                </div>
                {articlesShown < resultArticlesBlogs.length &&
                    <div class="ns-articles-loadmore-wrap">
                        <a 
                            href="javascript:void(0)"
                            aria-label="Load more articles"
                            onClick={loadMore} 
                            class="ns-articles-loadmore"
                        >
                            Load More
                        </a>
                    </div>
                }
            </div>
        </div>
    )
}
